import { SET_VEHICLES_MODEL_LIST, SET_VEHICLES_MODEL_INFO } from './constant';

const DEFAULT_STATE = {
  list: null,
  info: null
};

const modelReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_VEHICLES_MODEL_LIST:
      return { ...state, list: action.payload };
    case SET_VEHICLES_MODEL_INFO:
      return { ...state, info: action.payload };
    default:
      return state;
  }
};

export default modelReducer;
